import { autocompleteQuery, autocompleteLocationsQuery } from '../lib/graphql';

export function getAutocompleteResults(input) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({
        query: autocompleteQuery,
        variables: {
          input
        },
        fetchPolicy: 'network-only'
      });

      return data;

    } catch (error) {
      return null;
    }
  };
}

export function getAllLocations() {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({
        query: autocompleteLocationsQuery,
        fetchPolicy: 'network-only'
      });

      return data;

    } catch (error) {
      return null;
    }
  };
}